// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.radio-inline-custom[data-v-60385552] {
  position: relative;
  padding-left: 33px;
}
.radio-inline-custom[data-v-60385552] .radio {
  position: absolute;
  left: 0px;
  top: 5px;
}
.radio-inline-custom[data-v-60385552] label {
  width: auto;
}
.radio-group-custom[data-v-60385552] .radio-group .error--text .input-group__messages {
  color: #ff5252 !important;
}
.radio-group-custom[data-v-60385552] .radio-group .input-group--error .input-group__details:before {
  background-color: #ff5252 !important;
}
.nominee-content[data-v-60385552] {
  position: relative;
  min-height: 35px;
  width: 100%;
  padding-top: 10px;
}
.nominee-content .nominee-btn[data-v-60385552] {
  position: absolute;
  top: -36px;
  right: 0px;
}
.nominee-content .call-nominee-btn[data-v-60385552] {
  position: absolute;
  top: -15px;
  right: 0px;
}
.bold-select[data-v-60385552] {
  font-weight: 600;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
